import React from 'react';
import { IconProps } from './types';

const InputMetricIcon: React.FC<IconProps> = props => {
  const { className, size = '32', fillColor = '#FCC275' } = props;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx="4" fill={fillColor} />
      <path
        d="M15.54 24.0797L19.05 17.9897L22.44 19.9397L25.97 13.8397L26.03 13.7397"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4497 14.4297L26.0297 13.7397L26.7197 16.3197"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9199 11.1096H12.3499L11.3599 14.8796L11.1299 12.1396L11.3599 11.0996H10.0799L10.3099 12.1396L10.0799 14.8796L9.07986 11.1096H8.50986C7.46986 11.1096 6.60986 11.9496 6.60986 13.0096V17.9496C6.60986 18.7996 7.30986 19.4996 8.16986 19.4996L8.83986 27.1296H12.5799L13.2499 19.4996H13.2599C14.1099 19.4996 14.8099 18.7996 14.8099 17.9496V13.0096C14.8099 11.9496 13.9699 11.1096 12.9099 11.1096H12.9199Z"
        fill="white"
      />
      <path
        d="M10.7097 10.5898C12.245 10.5898 13.4897 9.34514 13.4897 7.80979C13.4897 6.27443 12.245 5.02979 10.7097 5.02979C9.17434 5.02979 7.92969 6.27443 7.92969 7.80979C7.92969 9.34514 9.17434 10.5898 10.7097 10.5898Z"
        fill="white"
      />
    </svg>
  );
};

export default InputMetricIcon;
